import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

import { firebaseOptions } from '@/config/firebase-options'

const app = initializeApp(firebaseOptions)

export const auth = getAuth(app)
export const db = getFirestore(app)
export { app }
